export default {
  'consent:page-hidden:text':
    "This page isn't fully visible because you haven't granted consent for functional cookies.",
  'consent:page-hidden:button': 'Open consent settings',
};
